import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SuccessNotificationComponent } from '../components/success-notification/success-notification.component';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { SnackbarNotificationComponent, SnackbarNotificationData } from '../components/snackbar-notification/snackbar-notification.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private readonly horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  private readonly verticalPosition: MatSnackBarVerticalPosition = 'top';
  private tokenExpiryLockUntil = 0;

  constructor(private readonly snackBar: MatSnackBar, private readonly dialog: MatDialog) { }

  showSuccess(message: string, duration = 3000) {
    if (this.isTokenExpiryLocked()) {
      return;
    }

    this.dialog.open(SuccessNotificationComponent, {
      data: { message, duration, type: 'success' },
      width: '450px',
      maxWidth: '90vw',
      disableClose: false,
      panelClass: 'success-notification-dialog',
      backdropClass: 'success-notification-backdrop'
    });
  }

  showError(message: string, duration = 5000) {
    if (this.isTokenExpiryLocked()) {
      return;
    }

    this.dialog.open(SuccessNotificationComponent, {
      data: { message, duration, type: 'error' },
      width: '450px',
      maxWidth: '90vw',
      disableClose: false,
      panelClass: 'error-notification-dialog',
      backdropClass: 'error-notification-backdrop'
    });
  }

  showInfo(message: string, duration = 3000) {
    if (this.isTokenExpiryLocked()) {
      return;
    }

    this.dialog.open(SuccessNotificationComponent, {
      data: { message, duration, type: 'info' },
      width: '450px',
      maxWidth: '90vw',
      disableClose: false,
      panelClass: 'info-notification-dialog',
      backdropClass: 'info-notification-backdrop'
    });
  }

  showPersistentToyotaInfo(message: string) {
    if (this.isTokenExpiryLocked()) {
      return;
    }

    this.dialog.open(SuccessNotificationComponent, {
      data: { message, duration: 0, type: 'toyota-info' },
      width: '450px',
      maxWidth: '90vw',
      disableClose: true,
      panelClass: 'toyota-info-notification-dialog',
      backdropClass: 'toyota-info-notification-backdrop'
    });
  }

  private show(data: SnackbarNotificationData, panelClass: string, duration: number): void {
    this.snackBar.openFromComponent(SnackbarNotificationComponent, {
      data,
      duration,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      panelClass: [panelClass]
    });
  }

  private isTokenExpiryLocked(): boolean {
    return Date.now() < this.tokenExpiryLockUntil;
  }

  private setTokenExpiryLock(duration: number): void {
    const lockDuration = Math.max(0, duration);
    this.tokenExpiryLockUntil = Date.now() + lockDuration;
  }

  showTokenExpired(duration = 3000) {
    this.setTokenExpiryLock(duration);
    this.dialog.closeAll();
    this.show({ title: 'Token Expired', message: 'Token expired. Redirecting to login page again..', icon: 'info' }, 'snackbar-error', duration);
  }

  showLoginFailed(duration = 3000) {
    this.setTokenExpiryLock(duration);
    this.dialog.closeAll();
    this.show({ title: 'Token Expired', message: 'Failed to login. Please try again.', icon: 'info' }, 'snackbar-error', duration);
  }
}

